// External Dependencies
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// Internal Dependencies
import {
  BackToButton,
  Subtitle,
} from 'components/shared';
import { useGetDistrictById } from 'gql/queries/districts';

// Local Dependencies
import DistrictLicensesTable from './DistrictLicensesTable';

// Component Definition
const DistrictLicenses = (): JSX.Element => {
  const { adminPortalId } = useParams();

  const { data: districtData } = useGetDistrictById(adminPortalId);

  if (!adminPortalId) {
    return <CircularProgress />;
  }

  return (
    <>
      <Box marginBottom={3}>
        <BackToButton
          context="Admin Portal Details"
          navigateTo={`/admin_portals/${adminPortalId}`}
        />
      </Box>

      <Box marginTop={3}>
        <Subtitle>
          {districtData ? districtData.districtById.label : 'Admin Portal'} Licenses
        </Subtitle>
      </Box>

      <DistrictLicensesTable adminPortalId={adminPortalId} />
    </>
  );
};

export default DistrictLicenses;
